import { resolveApiUrl } from "../../../../utils/url/urlResolver";

export type AlternativeProductDTO = {
  stockAmount: number;
  code: string;
  designation: string;
  sapMaterialNumber: string;
  url: string;
};

type AlternativeProducts = {
  alternativeProducts: AlternativeProductDTO[];
};

export async function fetchAlternativeProducts(productCode: string): Promise<AlternativeProducts> {
  const apiUrl = resolveApiUrl(`/cart/${productCode}/alternatives`);

  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data = await response.json();
    return data;
  }
  throw new Error("Error fetching data");
}
